import { useState } from 'react';

const STORAGE_KEY = 'ridgen:layer-control';

export interface LayerControlOverlays {
  showWind: boolean;
  showBoundary: boolean;
  showLocations: boolean;
  showPublicLand: boolean;
}

function loadState(): LayerControlOverlays {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<LayerControlOverlays>;
      return {
        showWind: parsed.showWind ?? true,
        showBoundary: parsed.showBoundary ?? true,
        showLocations: parsed.showLocations ?? true,
        showPublicLand: parsed.showPublicLand ?? false,
      };
    }
  } catch {
    // ignore parse errors
  }
  return { showWind: true, showBoundary: true, showLocations: true, showPublicLand: false };
}

function saveState(state: LayerControlOverlays): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore storage errors
  }
}

export function useLayerControl() {
  const [overlays, setOverlays] = useState<LayerControlOverlays>(loadState);

  function setShowWind(val: boolean) {
    const next = { ...overlays, showWind: val };
    setOverlays(next);
    saveState(next);
  }

  function setShowBoundary(val: boolean) {
    const next = { ...overlays, showBoundary: val };
    setOverlays(next);
    saveState(next);
  }

  function setShowLocations(val: boolean) {
    const next = { ...overlays, showLocations: val };
    setOverlays(next);
    saveState(next);
  }

  function setShowPublicLand(val: boolean) {
    const next = { ...overlays, showPublicLand: val };
    setOverlays(next);
    saveState(next);
  }

  return { overlays, setShowWind, setShowBoundary, setShowLocations, setShowPublicLand };
}
